export default __webpack_public_path__ + "static/media/UNMISS_opening_the_gates.ac274706.jpg";